import { AttachmentScanStatus } from '../models/Attachment';
import { emailApiClient } from './emailApiClient';

export interface ThreadAttachment {
  fileId: string;
  fileName: string;
  scanStatus: AttachmentScanStatus;
}

export interface ThreadContact {
  contactId: string;
  previousContactId: string | null;
  relatedContactId?: string | null;
  initiationMethod: string;
  initiationTimestamp: string;
  disconnectTimestamp: string | null;
  from?: string | null;
  to?: string[];
  cc?: string[];
  subject?: string | null;
  direction?: string | null;
  deliveredTo?: string | null;
  bodyHtml?: string | null;
  attachments?: ThreadAttachment[];
}

export const fetchEmailThread = async (contactId: string): Promise<ThreadContact[]> => {
  const params = new URLSearchParams({ contactId });

  const response = await emailApiClient(`/thread?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as { meta: { version: string }; data: ThreadContact[] };
  return json.data ?? [];
};
